<template>
  <div class="player-inner max-width" v-if="song">

    <div class="controlsOuter">
      <div class="controlsInner">
        <div class="loading"></div>

        <div v-if="!isPlaying" class="btn playBtn" @click.prevent="play">
          <img src="/themes/caramba/assets/images/play.svg" />
        </div>
        <div v-else class="btn pauseBtn" @click.prevent="pause">
          <img src="/themes/caramba/assets/images/pause.svg" />
        </div>
      </div>
    </div>

    <div class="progressOuter">
      <div class="progressBg"></div>
      <div class="progress" ref="progressBar"></div>
      <div class="progressSlider"></div>

      <div class="timerBlock arial timer-values"><span class="timer" ref="timer">0:00</span> / <span class="duration" ref="duration">0:00</span></div>
    </div>

    <div class="title tracklist">{{activeIndex}}. {{song.title}}</div>

    <album-downloads-handler :user="user" :song="song"></album-downloads-handler>
  </div>
</template>

<script>
import {Howl} from 'howler';
import AlbumDownloadsHandler from './AlbumDownloadsHandler.vue';

export default {
  props: ['songs', 'activeIndex', 'user'],

  data() {
    return {
      song: undefined,
      songHandler: undefined,
      isPlaying: false,

      // bar animation
      rAF: undefined,
      startingPoint: 60,
      endingPoint: 90
    
    }
  },

  watch: {
    activeIndex: function(newVal, oldVal) {
      this.pause();
      this.load(newVal);
      this.updateIcons();
      this.play();
    }
  },

  created() {
    const defaultIndex = this.$props.activeIndex;
    this.load(defaultIndex);
    this.updateIcons();

    const self = this;
    window.addEventListener('blur', self.pause);
  },

  destroyed() {
    this.pause();
    
    const self = this;
    window.removeEventListener('blur', self.pause);
  },

  methods: {
    play: function() {

      console.log ("isPlaying?", this.isPlaying, !this.isPlaying, this.songHandler)

      if(!this.isPlaying) {
        this.songHandler.play();
        this.isPlaying = true;
      }
    },

    pause: function() {
      this.songHandler.pause();
      this.isPlaying = false;
    },

    checkLimit: function() {


      if( this.songHandler._duration > 61 ) {
        // Start track 1 minute into the song
        if( this.songHandler.seek() <= this.startingPoint || 
            this.songHandler.seek() >= this.endingPoint ) 
        {
          this.startingPoint = 60;
          this.endingPoint = 90;
          this.songHandler.seek( this.startingPoint );
        }
      } else {
        this.startingPoint = 0;
        this.endingPoint = 30;
        this.songHandler.seek(this.startingPoint);
      }
    
      // Start updating the progress of the track.
      const self = this;
      this.rAF = requestAnimationFrame(self.step.bind(self));
      // Show the pause button
      //el.pauseBtn.style.display = 'block';
    },

    step: function() {

      //console.log("STEP METHOD");

      if( typeof this.songHandler !== 'undefined' ) {
        // Determine our current seek position.
        let seek = this.songHandler.seek() || 0;

        if( seek > this.endingPoint ) {
          cancelAnimationFrame(this.rAF);
          setTimeout(() => { this.pause(); }, 150);
        } else {

          const currentPos = Math.round(seek) - this.startingPoint;
          const progressPos = seek - this.startingPoint;
          const duration = this.endingPoint - this.startingPoint;

          this.$refs.timer.innerHTML = this.formatTime( currentPos );
          this.$refs.duration.innerHTML = this.formatTime( duration ); // Math.round(sound.duration())
          this.$refs.progressBar.style.width = ( ( ( progressPos / duration ) * 100 ) || 0 ) + '%';
        }

        // If the sound is still playing, continue stepping.
        //if (this.songHandler.playing()) {
          // Nota del 01 Nov 2019:
          // ho sostituito this.songHandler.playing() con this.isPlaying
          // perché per qualche misteriosa ragione su chrome al primo click
          // il metodo this.songHandler.playing() non veniva eseguito
        if (this.isPlaying) {
          const self = this;
          this.rAF = requestAnimationFrame(self.step.bind(self));
        }
      } else {
        cancelAnimationFrame(this.rAF);
      }
    },

    formatTime: function(secs) {
      const minutes = Math.floor(secs / 60) || 0;
      const seconds = (secs - minutes * 60) || 0;

      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    },

    load: function(id) {


      this.song = this.$props.songs[id - 1];
      this.songHandler = new Howl({
        src: this.song.stream_url,
        html5: true,
        onplay: this.checkLimit
      });
    },

    updateIcons: function() {
    }
  },

  components: {
    'album-downloads-handler': AlbumDownloadsHandler
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/vue/components/AlbumPlayer.vue